import Request from './request';
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import store from "../store";
async function fetch(data) {
    return Request('get', "api/registers/index", data);
}

async function fetchOne(id) {
    return Request('get', "api/registers/view/" + id);
}

async function del(id) {// 删除数据
    return Request('delete', "api/registers/delete/" + id);
}
  
async function save(id,data) {
    return Request('post', "api/registers/make-add-shop/" + id , data);
}

async function exports(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request("get", "api/registers/export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

export default {
    fetch,
    fetchOne,
    del,
    save,
    exports
}